import { ChevronLeft, ChevronRight } from 'lucide-react';

import { PAGE_SIZES } from '../lib/paging';
import { Button } from './Button';

interface Props {
  page: number;
  size: number;
  total: number;
  onPage: (page: number) => void;
  onSize: (size: number) => void;
}

/** Footer for offset-paginated tables. */
export function Pagination({ page, size, total, onPage, onSize }: Props) {
  const pages = Math.max(1, Math.ceil(total / size));
  return (
    <nav
      aria-label="Paginação"
      className="flex flex-wrap items-center justify-between gap-3 border-t border-line px-4 py-2.5 text-xs text-fg-muted"
    >
      <span aria-live="polite">
        {(page - 1) * size + 1}–{Math.min(page * size, total)} de {total}
      </span>
      <div className="flex items-center gap-3">
        <label className="flex items-center gap-2">
          Por página
          <select
            value={size}
            onChange={(e) => {
              onSize(Number(e.target.value));
            }}
            className="h-7 rounded-md border border-line-strong bg-canvas px-2 text-[13px] text-fg"
          >
            {PAGE_SIZES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </label>
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            className="h-7 px-2"
            aria-label="Página anterior"
            disabled={page <= 1}
            onClick={() => {
              onPage(page - 1);
            }}
          >
            <ChevronLeft aria-hidden="true" className="size-4" />
          </Button>
          <span className="tabular-nums">
            {page} / {pages}
          </span>
          <Button
            variant="ghost"
            className="h-7 px-2"
            aria-label="Próxima página"
            disabled={page >= pages}
            onClick={() => {
              onPage(page + 1);
            }}
          >
            <ChevronRight aria-hidden="true" className="size-4" />
          </Button>
        </div>
      </div>
    </nav>
  );
}
